export default "__VITE_ASSET__9e23cde5__"